import { isProduction } from '@masfront/common-core'
import { history } from '@masfront/common-csr'
import featureFlags, {
  ReactRouterDOMSource,
  CookiesSource,
  ConfigCatSource,
} from '@masfront/common-feature-flags'
import * as configCat from 'configcat-js'

import LeadsService from '../../../pages/LeadsPage/services/leads.service'
import AppDeps from '../model/AppDeps'

import AddressService from '~/address/services/address.service'
import AgentService from '~/agent/services/agent.service'
import AnalyticsService from '~/analytics/services/analytics.service'
import AuthService from '~/auth/services/auth.service'
import BundlesService from '~/bundles/services/bundles.service'
import CheckoutService from '~/checkout/services/checkout.service'
import BuildtimeConfig from '~/config/model/BuildtimeConfig'
import RuntimeConfig from '~/config/model/RuntimeConfig'
import ContractService from '~/contract/services/contract.service'
import CustomerService from '~/customer/services/customer.service'
import LegalService from '~/legal/services/legal.service'
import NextStepsService from '~/legal/services/nextSteps.service'
import LineService from '~/line/services/line.service'
import MasterDataService from '~/masterData/services/masterData.service'
import IbanService from '~/payments/iban/services/iban.service'
import TariffService from '~/tariff/services/tariff.service'

export default class AppDepsBuilder {
  constructor(private buildtimeConfig: BuildtimeConfig, private runtimeConfig: RuntimeConfig) {}

  buildFeatureFlagsService() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis as any
    const reactRouterDOMSource = new ReactRouterDOMSource(global, history)
    const cookiesSource = new CookiesSource(global)

    const configCatSource = new ConfigCatSource({
      configCat,
      isClient: true,
      options: {
        SDKKey: this.runtimeConfig.configCatSDKKey,
        defaultFlags: {},
      },
    })

    featureFlags.init({
      defaultFeatureFlags: this.runtimeConfig.defaultFeatureFlags,
      debug: !isProduction(this.runtimeConfig.environment),
    })

    featureFlags.initSource('QUERY_PARAMS', reactRouterDOMSource)
    featureFlags.initSource('COOKIES', cookiesSource)
    featureFlags.initSource('REMOTE_FLAGGER', configCatSource)
    return featureFlags
  }

  public buildAppDeps(): AppDeps {
    const { apiGateway, salesClusterUrl } = this.runtimeConfig
    return {
      buildtimeConfig: this.buildtimeConfig,
      runtimeConfig: this.runtimeConfig,
      lineService: new LineService(apiGateway),
      agentService: new AgentService(apiGateway),
      tariffService: new TariffService(apiGateway),
      masterDataService: new MasterDataService(apiGateway),
      addressService: new AddressService(apiGateway),
      legalService: new LegalService(apiGateway),
      bundlesService: new BundlesService(apiGateway),
      featureFlagsService: this.buildFeatureFlagsService(),
      authService: new AuthService(
        this.runtimeConfig.authn.apiGateway,
        this.runtimeConfig.authn.clientId,
        'masmovil',
      ),
      checkoutService: new CheckoutService(apiGateway),
      nextStepsService: new NextStepsService(apiGateway),
      customerService: new CustomerService(apiGateway),
      contractService: new ContractService(apiGateway),
      analyticsService: new AnalyticsService(this.runtimeConfig.analytics.UAID),
      ibanService: new IbanService(apiGateway),
      leadsService: new LeadsService(salesClusterUrl),
    }
  }
}
